import FeatherIcon from 'feather-icons-react';

const Icon = FeatherIcon;

export default Icon;
